import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';
import { Text, SimpleFlexbox } from 'ctm-components';
import { getHasSavedResults } from 'ctm-selectors/selectors/results';
import { getFeatureFlag } from 'ctm-selectors/selectors/base';
import { SimpleRadioButtonGroup } from '../../form/simple_radio_button_group/simple_radio_button_group';

class _SidebarDisplayToggle extends PureComponent {

    /**
   * Handles the on change method
   * @param {Event} event - the on change event
   * @param {string} value - the value to set
   */
    onChange = (event, value) => {
        const { displayMode, setResultsConfigValue, previousDisplayMode } = this.props;

        if (displayMode !== value) {
            // Set Display Mode
            setResultsConfigValue(value, 'displayMode');

            // Set Previous Display mode
            if (displayMode !== previousDisplayMode) {
                setResultsConfigValue(value, 'previousDisplayMode');
            }
        }
    };

    render = () => {
        const { displayMode } = this.props;
        const hasSavedResults = getHasSavedResults() || getFeatureFlag('prefillHasSavedResults');
        return (
            <div>
                {hasSavedResults ? (
                    <></>
                ) : (
                    <>
                        <SimpleFlexbox padding="bottom_xsmall">
                            <Text size="large" variant="margin_top_bottom_small"><strong>View type</strong></Text>
                        </SimpleFlexbox>
                        <SimpleRadioButtonGroup {...this.props} value={displayMode} onChange={this.onChange} />
                    </>
                )}

            </div>
        );
    };

}

_SidebarDisplayToggle.propTypes = {
    displayMode: PropTypes.string.isRequired,
    previousDisplayMode: PropTypes.string.isRequired,
    setResultsConfigValue: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string
        })
    ).isRequired
};

const mapStateToProps = (state) => {
    return {
        displayMode: resultsConfigSelector(state).getIn(['displayMode']),
        previousDisplayMode: resultsConfigSelector(state).getIn(['previousDisplayMode'])
    };
};

const mapDispatchToProps = (dispatch) => ({
    setResultsConfigValue: (value, key) => {
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key,
            value
        });
    }
});

const SidebarDisplayToggle = connect(mapStateToProps, mapDispatchToProps)(_SidebarDisplayToggle);

export { SidebarDisplayToggle, _SidebarDisplayToggle };
